import React, { MouseEvent } from 'react';
import { ModalProps } from '@mui/material/Modal';
import { CircularProgress } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import { Button, Typo, Modal } from 'components/primitives';
import useStyles from './ConfirmationModal.styles';

interface IConfirmationProps {
  loading?: boolean;
  disabled?: boolean;
  title?: string;
  rightTitle?: string;
  onConfirm?: (e: MouseEvent, confirm: boolean) => void;
}

type ConfirmationModalViewProps = IConfirmationProps & ModalProps;

const ConfirmationModalView: React.FC<ConfirmationModalViewProps & BoxProps> = ({
  // className,
  loading = false,
  disabled = false,
  title = 'Please confirm',
  rightTitle = 'Confirm',
  onConfirm,
  ...props
}) => {
  const classes = useStyles();
  const onTouchButton = (e: MouseEvent, confirm: boolean) => {
    if (!loading) {
      onConfirm && onConfirm(e, confirm);
    }
  };

  return (
    <Modal {...props} className={classes.root}>
      <React.Fragment>
        <Box className={classes.content}>
          <Typo variant='h3' mb={2}>
            {title}
          </Typo>
          {props.children}
        </Box>
        <Box className={classes.footer}>
          {!loading && (
            <Button onClick={(e) => onTouchButton(e, false)} alternate fullWidth>
              Cancel
            </Button>
          )}
          <Button
            disabled={disabled}
            onClick={(e) => onTouchButton(e, true)}
            neutral={loading}
            endIcon={loading && <CircularProgress color='inherit' size={16} sx={{ mr: '4px' }} />}
            fullWidth>
            {loading ? 'Please wait' : rightTitle}
          </Button>
        </Box>
      </React.Fragment>
    </Modal>
  );
};

export default ConfirmationModalView;
